//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.GEpkDbParams.ts                              </Name>
//    <Description>	DB Parametry EPK													</Description>
//    <Author>      Tomáš Hažmuka														</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019									</Copyright>
//    <Created>     2019-04-04															</Created>
//  </FileHeader>

namespace Gordic.Epk.WebControls {

    export class IEpkCheckBoxSetting {
        constructor(enabled?: boolean, checked?: boolean, visible?: boolean) {
            this.enabled = enabled == null ? true : enabled;
            this.checked = checked == null ? true : checked;
            this.visible = visible == null ? true : visible;
        }
        /** povolení */
        enabled: boolean;
        /** zaškrtnuto */
        checked: boolean;
        /** viditelnost */
        visible: boolean;
    }

    /** enum - umístění vizuálního podpisu při vyřizování žádosti */
    export enum epk_povumipod_enum {
        /** Ne podpis není vizuálně umístěn */
        Ne = 0,
        /** Ano, pouze el. obrazy */
        Ano = 1,
        /** Ano, včetně příloh */
        AnoVcetnePriloh = 2
    }

    /** enum - Načítání seznamu pravých stran */
    export enum epk_ssl_cti_sez_enum {
        /** načtení až po stisku tlačítka */
        PoStiskuTlacitka = 0,
        /** okamžité načtení pravé strany */
        OkamziteNacteni = 1
    }

    interface IEpkMenuState {
        /** povoleno */
        enabled: boolean
    }

    export class GEpkDbParamsNew {

        /** detail žádosti pouze ke čtení */
        ReadOnly: boolean;
        EpkParams: Gordic.Gin.WebClient.GEpkParamsDto;
        EpkOpt: Gordic.Gin.WebClient.GEpkOptDto;

        /** data řádku */
        row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null;
        /** příznak, že právě probíhá podepisování */
        signing: boolean;

        /** DTO - informace o navázané šabloně (pouze na úkonu Rozhodnout pro UKR) */
        LinkedTemplate: Wfl.Interface.GEpkLinkedTemplateDto;
        /** hodnota vyřízení */
        vyriditState: Gordic.Wfl.Interface.TypPozadavkuEpk | null;
        /** badge umístění ručního vizuálního podpisu */
        badgeUmisteniPodpisu: any;

        //#region -- typy vyřízení --

        /** časové razítko */
        casoveRazitko: IEpkCheckBoxSetting;
        /** časové razítko k příloze */
        casoveRazitkoPriloha: IEpkCheckBoxSetting;
        /** včetně příloh */
        podepsatPrilohy: IEpkCheckBoxSetting;
        /** podepsat */
        podepsat: IEpkCheckBoxSetting;
        /** schválit */
        schvalit: IEpkCheckBoxSetting;
        /** podepsat a schválit */
        podepsataschvalit: IEpkCheckBoxSetting;
        /** posoudit */
        posoudit: IEpkCheckBoxSetting;
        /** vzít na vědomí */
        vzitnavedomi: IEpkCheckBoxSetting;
        /** splnit (specialita pro Ukrajinu) */
        splnit: IEpkCheckBoxSetting;
        /** rozhodnout (specialita pro Ukrajinu) */
        rozhodnout: IEpkCheckBoxSetting;
        /** zkonvertovat */
        zkonvertovat: IEpkCheckBoxSetting;
        /** zkonvertovat přílohy */
        zkonvertovatPrilohy: IEpkCheckBoxSetting;
        /** podepsat i ne PDF přílohy */
        podepsatPrilohyNePDF: IEpkCheckBoxSetting;
        /** přidělit (Specialita MD) */
        pridelit: IEpkCheckBoxSetting;
        /** předat (Specialita MD) */
        predat: IEpkCheckBoxSetting;
        /** schválení vyřízení spisu (Specialita MD) */
        schvaleniVyrizeniSpisu: IEpkCheckBoxSetting;

        //#endregion

        /** menu tlačítko vyřídit */
        menuSchvalit: IEpkMenuState;
        /** menu tlačítko posoudit */
        menuPosoudit: IEpkMenuState;
        /** menu tlačítko vráceno k přepracování */
        menuZamitnout: IEpkMenuState;
        /** přidat vyřizující soubor k vyřízení */
        pridatVyrizSoubor: IEpkMenuState;
        /** element gridu */
        grid: JQuery<HTMLElement>;

    }

 //   export class GEpkDbParams {

 //       /** DTO - informace o navázané šabloně (pouze na úkonu Rozhodnout pro UKR) */ 
 //       LinkedTemplate: Wfl.Interface.GEpkLinkedTemplateDto;

 //       /** data řádku */
 //       row: Gordic.Wfl.Interface.GPodpisovaKnihaDto | null;

 //       //Vyrizeno?: boolean;

 //       DateInterval?: {
 //           start: Date,
 //           end: Date
 //       };
 //       DateIntervalVisible?: DatFiltrZobEnum;

 //       /** Katergorie důvodu podpisu - příznak použití značky */
 //       ktgDpoDpoCfgPrizZnacka: number;

 //       /** Povolení úkonu podpisu EPK */
 //       povoleniUkonuPodpisuEpk: boolean;

 //       /** EPK - Limit zablokování žádosti při asynchronním vyřízení */
 //       epk_asynclimit: number;

 //       /** EPK - Povolení editace elektronických dokumentů ze seznamu žádostí */
 //       epk_povedeldok: boolean;

 //       /** EPK - Zobrazovat filtr dle typu podpisu */
 //       epk_shsigtypfil: boolean;

 //       /** SSL - Filtrovat seznamy osob pro předání/přidělení dle vazby funkce na deník */
 //       ssl_pripreomez: number;

 //       /** Zobrazení pole pro zadání důvodu vyřízení při kladném vyřízení (Ano-1, Ne-0) */
 //       epk_shreaspos: boolean;
 //       /** SSL EPK - Rozšíření pro odsouhlasení přidělení/předání dokumentů a vyřízení spisů */
 //       ssl_epk_plus2: boolean;
 //       /** SSL - Super administrátor (datumové rozsahy) */
 //       ssl_superadmin: boolean;
 //       /** zobrazení náhledu elektronického souboru */
 //       gin_ele_dmspres: boolean;
 //       /** GIN ELE - Okno příloh dokumentu - Povolení označení příloh pro podpis v EPK */
 //       gin_ele_okprepk: boolean;
 //       /**  SSL EPK - Uživatelský sloupec F - název sloupce zobrazovaný uživateli */
 //       epk_uziv_sl_fn: string;
 //       /** SSL - Načítání seznamu pravých stran (0 - načtení až po stisku tlačítka, 1 - okamžité načtení pravé strany) */
 //       ssl_cti_sez: epk_ssl_cti_sez_enum;
 //       /** GIN SGN - Pozice obrázku doplněného po přidání el. podpisu (např. do PDF) */
 //       gin_pdf_pictpos: number;
 //       /** EPK - Povolení umístění vizuálního podpisu při vyřizování žádosti */
 //       epk_povumipod: epk_povumipod_enum;

 //       /** EPK - povolení podepsání pouze příloh */
 //       epk_povpodppri: boolean;
 //       /** EPK SGN - Řízení a viditelnost zaškrtávátka "Podepsat i přílohy, které nejsou v PDF" */
 //       epk_zasknepdfpr: number;
 //       /** EPK - Řízení a viditelnost zaškrtávátka "Přílohy - časové razítko" */
 //       epk_zaskprilcr: number;
 //       /** EPK - Řízení a viditelnost zaškrtávátka "Před podepsáním zkonvertovat" */
 //       epk_zaskkonv: number;
 //       /** EPK - Řízení a viditelnost zaškrtávátka "Přílohy zkonvertovat" */
 //       epk_zaskprikonv: number;

	//	/** text. značka */
	//	znackaShortText: string;
	//	/** text. číslo jednací */
	//	textCJShortDBParam: string;
	//	/** Jedná se o fázi USU? */
	//	isFazeUsu: boolean;
	//	/** zda má uživatel platný certifikát navázaný na osobu */
	//	isExistNavazCert: boolean;
	//	/** zda je funkce napojena na roli s úkonem podpisu */
	//	jeFunkceNapojenaNaRoliSUkonemPodpisu: boolean;
	//	/** příznak použití časového razítka */
	//	priz_cas_raz: number;
	//	/** je DpoCfg prázdné (null)? */
	//	isDpoCfgNull: boolean;
	//	/** příznak použití značky */
 //       dpoCfgPrizZnacka: number;

	//	/** 
 //        *  SSL EPK - Rozšíření pro posuzování / odsouhlasení dokumentů (EPK+)
 //        *  -1 - Ne  - pouze podepsat; podepsat a schválit
	//	 *   0 - Ne  - úkony Posoudit a Vzít na vědomí nelze použít
	//	 *   1 - Ano - je možno využít speciální úkon Posoudit
	//	 *   2 - Ano - včetně vzít na vědomíJe možno využít speciální úkony Posoudit a Vzít na vědomí
	//	 *   3 - Ano - včetne splnit a vzít na vědomí
 //        * */
 //       ssl_epk_plus: -1 | 0 | 1 | 2 | 3 ;

	//	/** EPK - Zobrazit úlohu Vráceno k přepracování */
	//	epk_zobrvrac: boolean;
	//	/** EPK - dny do termínu (těsně nevyřízené záznamy) */
	//	gin_epk_updoter: number;
	//	/** 
 //        * EPK - Pohled supervisora 
 //        * - 1: za celý uřad
 //        * - 2: za aktuální spis. uzle a podřízené spis. uzly
 //        * */
	//	epk_prehl_org: number;
	//	/** EPK - Zobrazovat EKO sloupce v seznamech */
	//	epk_ekosloupce: boolean;

 //       /** GIN SGN TS - Způsob přidání časového razítka při podepsání elektronického obrazu */
 //       gin_ele_craz_ob: number;
 //       /** GIN SGN TS - Způsob přidání časového razítka při podepsání el. příloh (sign, timestamp) */
 //       gin_ele_craz_pr: number;

	//	/** EPK - Řízení a viditelnost zaškrtávátka "Včetně příloh" */
	//	epk_zaskpril: string;
	//	/** EPK SGN - Řízení a viditelnost zaškrtávátka Podepsat - časové razítko */
	//	epk_zaskpodcr: string;
	//	/** EPK - Povolení při vyřízení požadavku/úkonu vkládat elektronický dokument s popisem vyřízení */
	//	epk_vlvyrizdok: boolean;
	//	/** EPK - Možnost přidat úkon Posouzení při vyřizování žádosti v EPK */
	//	epk_mozpredkpos: boolean;
	//	/** EPK - Kontrola navázaných certifikátů */
	//	epk_kontnavcer: number;
	//	/** GIN SGN - povolení používat kategorie důvodu podpisu */
	//	gin_sgn_ktgdp: boolean;
	//	/** SSL EPK - Povolení změnit typ úkonu prováděný nad žádostí v podpisové knize */
	//	ssl_epk_zmeuko: boolean;
	//	/** EPK - Zobrazovat závislé úkony/požadavky schvalovacích procesů (závislé na vyřízení předchozích) */
 //       epk_schpznav: boolean;
 //       /** EPK - Povolení hromadného vyřízení žádostí */
 //       epk_povhrovyriz: boolean;

 //       /** příznak, že právě probíhá podepisování */
 //       signing: boolean;

 //       //#region * parametry k vyřízení *

 //       /** hodnota vyřízení */
 //       vyriditState: Gordic.Wfl.Interface.TypPozadavkuEpk | null;


 //       /** menu tlačítko vyřídit */
 //       menuSchvalit: {
 //           /** povoleno */
 //           enabled: boolean
 //       }
 //       /** menu tlačítko posoudit */
 //       menuPosoudit: {
 //           /** povoleno */
 //           enabled: boolean
 //       }
 //       /** menu tlačítko vráceno k přepracování */
 //       menuZamitnout: {
 //           /** povoleno */
 //           enabled: boolean
 //       }
 //       /** přidat vyřizující soubor k vyřízení */
 //       pridatVyrizSoubor: {
 //           /** povoleno */
 //           enabled: boolean
 //       }


 //       /** časové razítko */
 //       casoveRazitko: IEpkCheckBoxSetting;
 //       /** časové razítko k příloze */
 //       casoveRazitkoPriloha: IEpkCheckBoxSetting;
 //       /** včetně příloh */
 //       podepsatPrilohy: IEpkCheckBoxSetting;
 //       /** podepsat */
 //       podepsat: IEpkCheckBoxSetting;
 //       /** schválit */
 //       schvalit: IEpkCheckBoxSetting;
 //       /** podepsat a schválit */
 //       podepsataschvalit: IEpkCheckBoxSetting;
 //       /** posoudit */
 //       posoudit: IEpkCheckBoxSetting;
 //       /** vzít na vědomí */
 //       vzitnavedomi: IEpkCheckBoxSetting;
 //       /** splnit (specialita pro Ukrajinu) */
 //       splnit: IEpkCheckBoxSetting;
 //       /** rozhodnout (specialita pro Ukrajinu) */
 //       rozhodnout: IEpkCheckBoxSetting;
 //       /** zkonvertovat */
 //       zkonvertovat: IEpkCheckBoxSetting;
 //       /** zkonvertovat přílohy */
 //       zkonvertovatPrilohy: IEpkCheckBoxSetting;
 //       /** podepsat i ne PDF přílohy */
 //       podepsatPrilohyNePDF: IEpkCheckBoxSetting;

 //       /** přidělit (Specialita MD) */
 //       pridelit: IEpkCheckBoxSetting;
 //       /** předat (Specialita MD) */
 //       predat: IEpkCheckBoxSetting;
 //       /** schválení vyřízení spisu (Specialita MD) */
 //       schvaleniVyrizeniSpisu: IEpkCheckBoxSetting;

 //       //#endregion

 //       /** typ požadavku: podepsat, schválit, ... */
 //       typPozadavku: TypPozadavkuEnum;
 //       /** pohledy supervisora */
 //       supervisor: Gordic.Wfl.Interface.EpkSupervisorEnum;

	//}

}